import React, { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import RuntimeParameter from './RuntimeParameter';
import RuntimeParameterUhomeSinglePhase from './RuntimeParameterUhomeSinglePhase';
import EnergyStatistics from './EnergyStatistics';
import EnergyStatisticsUhomeSinglePhase from './EnergyStatisticsUhomeSinglePhase';
import DataHistory from './DataHistory';
import DataHistoryUhomeSinglePhase from './DataHistoryUhomeSinglePhase';
import AlarmHistory from './AlarmHistory';
import DryContactData from './DryContactData';
import AirConditionerData from './AirConditionerData';
import RuntimeParameterUhomeThreePhase from './RuntimeParameterUhomeThreePhase';
import EnergyStatisticsUhomeThreePhase from './EnergyStatisticsUhomeThreePhase';
import DataHistoryUhomeThreePhase from './DataHistoryUhomeThreePhase';

function DataAnalysis(props) {
    const { t } = useTranslation();
    const {Timezone, inverterSelectOptions, SN, model, protocol, handleSelectSN} = props
    const [activeMenu, setActiveMenu] = useState(0) 

    return (
        <div className="data-analysis">
            <div className="data-nav"> {/* 左侧菜单栏 */}
                <ul>
                    <li className={activeMenu==0 ? 'active' : null} onClick={() => setActiveMenu(0)}>{t('Runtime Parameter')}</li>
                    <li className={activeMenu==1 ? 'active' : null} onClick={() => setActiveMenu(1)}>{t('Energy Statistics')}</li>
                    <li className={activeMenu==2 ? 'active' : null} onClick={() => setActiveMenu(2)}>{t('Historical Data')}</li>
                    <li className={activeMenu==3 ? 'active' : null} onClick={() => setActiveMenu(3)}>{t('Historical Event')}</li>
                    {protocol == 'Sinexcel' && <li className={activeMenu==4 ? 'active' : null} onClick={() => setActiveMenu(4)}>{t('DryContact Data')}</li>}
                    {protocol == 'Sinexcel' && <li className={activeMenu==5 ? 'active' : null} onClick={() => setActiveMenu(5)}>{t('AirConditioner Data')}</li>}
                </ul>
            </div>
            <div className="data-content">  {/* 主体内容 */}
                { 
                    activeMenu == 0 ? 
                    (protocol == "Uhome-SinglePhase" ? <RuntimeParameterUhomeSinglePhase Timezone={Timezone} inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} handleSelectSN={handleSelectSN} /> 
                        : protocol == "Uhome-ThreePhase" ? <RuntimeParameterUhomeThreePhase Timezone={Timezone} inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} handleSelectSN={handleSelectSN} />
                        : <RuntimeParameter Timezone={Timezone} inverterSelectOptions={inverterSelectOptions} SN={SN} model={model} protocol={protocol} handleSelectSN={handleSelectSN} />
                    )
                    :    
                    activeMenu == 1 ? 
                    (protocol == "Uhome-SinglePhase" ? <EnergyStatisticsUhomeSinglePhase inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} handleSelectSN={handleSelectSN} />
                        : protocol == "Uhome-ThreePhase" ? <EnergyStatisticsUhomeThreePhase inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} handleSelectSN={handleSelectSN} />
                        : <EnergyStatistics inverterSelectOptions={inverterSelectOptions} SN={SN} model={model} protocol={protocol} handleSelectSN={handleSelectSN} />) 
                    :
                    activeMenu == 2 ? 
                    (protocol == "Uhome-SinglePhase" ? <DataHistoryUhomeSinglePhase Timezone={Timezone} inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} handleSelectSN={handleSelectSN} />
                        : protocol == "Uhome-ThreePhase" ? <DataHistoryUhomeThreePhase Timezone={Timezone} inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} handleSelectSN={handleSelectSN} />
                        : <DataHistory Timezone={Timezone} inverterSelectOptions={inverterSelectOptions} SN={SN} model={model} protocol={protocol} handleSelectSN={handleSelectSN} />
                    )
                    :
                    activeMenu == 3 ?  <AlarmHistory inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} handleSelectSN={handleSelectSN} /> : 
                    activeMenu == 4 && protocol == 'Sinexcel' ? <DryContactData inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} handleSelectSN={handleSelectSN} /> :
                    activeMenu == 5 && protocol == 'Sinexcel' ? <AirConditionerData inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} handleSelectSN={handleSelectSN} /> :
                    null
                }
            </div>
        </div>
    )
}

export default DataAnalysis;